import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import objectFitVideos from "object-fit-videos"

// Components
import Icon from "components/Stacker/components/Icon/Icon"

// Styles
import "./BgVideo.scss"

function BgVideo(props) {
  const [isPlaying, setisPlaying] = useState(false)
  const videoRef = useRef()
  const videoWrapper = useRef()

  useEffect(() => {
    const onPause = () => {
      setisPlaying(false)
    }

    const onPlay = () => {
      setisPlaying(true)
    }

    const onPlaying = () => {
      setisPlaying(true)
    }

    const onVideoLoaded = () => {
      videoWrapper.current.classList.add("BgVideo--video-loaded")
    }

    const brightcove = document.createElement("script")
    brightcove.src =
      "//players.brightcove.net/5088318296001/S1Orvq49_default/index.min.js"
    brightcove.async = true
    document.getElementsByTagName("head")[0].appendChild(brightcove)

    objectFitVideos()

    const video = videoRef.current
    if (video) {
      video.addEventListener("pause", () => {
        onPause()
      })
      video.addEventListener("play", () => {
        onPlay()
      })
      video.addEventListener("playing", () => {
        onPlaying()
      })
      video.addEventListener("canplay", () => {
        onVideoLoaded()
      })
    }

    return () => {
      const video = videoRef.current
      if (video) {
        video.removeEventListener("pause", onPause)
        video.removeEventListener("play", onPlay)
        video.removeEventListener("playing", onPlaying)
        video.removeEventListener("canplay", onVideoLoaded)
      }
    }
  }, [])

  function togglePlay(isPlaying) {
    if (isPlaying) {
      videoRef.current.pause()
    } else {
      videoRef.current.play()
    }
  }

  const { dataAcct, vidId, fixed, controls, poster } = props

  return (
    <div className="BgVideo" ref={videoWrapper}>
      <div className="BgVideo__video-wrapper">
        <video
          ref={videoRef}
          className={cx("BgVideo__video video-js", {
            "BgVideo__video--fixed": fixed,
          })}
          autoPlay
          loop
          muted
          poster={poster}
          playsInline
          id={`bg-vid-${vidId}`}
          data-video-id={vidId}
          data-account={dataAcct}
          data-player="S1Orvq49"
          data-embed="default"
          data-application-id
        >
          <track kind="captions" srcLang="en" />
          <track kind="descriptions" srcLang="en" />
        </video>
        {controls && videoRef.current && (
          <button
            aria-label={`${
              isPlaying ? "pause background video" : "play background video"
            }`}
            className="BgVideo__button"
            onClick={() => togglePlay(isPlaying)}
          >
            <div className="BgVideo__icon-wrapper">
              {isPlaying && <Icon iconName="icon-pause" />}
              {!isPlaying && <Icon iconName="icon-play" />}
            </div>
          </button>
        )}
      </div>
      <div className="BgVideo__bg-image-wrapper">
        <img alt="" className="BgVideo__bg-image" src={poster} />
      </div>
    </div>
  )
}
BgVideo.propTypes = {
  dataAcct: PropTypes.string,
  vidId: PropTypes.string,
  fixed: PropTypes.bool,
  controls: PropTypes.bool,
  poster: PropTypes.string,
}
export default BgVideo
